package dev.bitspittle.droidconSf24.pages.sections.conclusion

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import dev.bitspittle.droidconSf24.utilities.heavyTextShadow
import com.varabyte.kobweb.compose.foundation.layout.Box
import org.jetbrains.compose.web.css.Position

@Page
@Composable
fun ThankYou2Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/conclusion/ThankYou2.md", mapOf("data-background-image" to listOf("images/cobweb2-dark.jpg"), "styles" to listOf("outlined-headers")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            Box(Modifier.height(10.cssRem))
            org.jetbrains.compose.web.dom.H1(attrs = { id("") }) {
                KobwebText("Thank You")
            }
            Div(Modifier.heavyTextShadow(10.px).textAlign(TextAlign.Left)) {
                Box(Modifier.height(13.cssRem))
                org.jetbrains.compose.web.dom.P {
                    FaGithub()
                    org.jetbrains.compose.web.dom.Text(" ")
                    com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/varabyte/kobweb") {
                        org.jetbrains.compose.web.dom.Text("https://github.com/varabyte/kobweb")
                    }
                    com.varabyte.kobweb.compose.dom.GenericTag("br", null)
                    org.jetbrains.compose.web.dom.Text(" ")
                    FaLinkedin()
                    org.jetbrains.compose.web.dom.Text(" ")
                    com.varabyte.kobweb.silk.components.navigation.Link("https://www.linkedin.com/in/hermandave/") {
                        org.jetbrains.compose.web.dom.Text("https://www.linkedin.com/in/hermandave/")
                    }
                }
            }
        }
    }
}
